module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ch":{"top":"联结你我 传送欢笑","bottom":"创建多维度欢乐社交空间"},"zh":{"top":"聯結你我，傳送歡笑","bottom":"創建多維度歡樂社交空間"},"en":{"top":" ","bottom":" "}}')
  delete Component.options._Ctor
}
